import React from 'react';

import Icon from 'views/site/Icon.js';

import Theme from 'styles/Theme.js';
import Utils from 'files/Utils.js';

/*
 * TrustBar
 *
 * Slim credibility strip directly under the hero, on the near-black ground the
 * storefront uses for it — desktop is a four-across row with label, subtext and
 * hairline dividers; mobile collapses to a 2×2 of short badges.
 *
 * Every claim is sourced from the owner's manuals rather than written to sound
 * reassuring: assembly is stated on every manual cover, the listings are
 * UL 217 / UL 539 / UL 2034, the batteries are sealed lithium manganese meeting
 * the 10-year tamper-resistant requirement, and the fire replacement guarantee
 * is a real published guarantee.
 */

const TrustBar = () => {

    const mobile = Utils.isMobile();

    const items = [
        { icon: 'flag-fill', label: 'Assembled', short: 'Made in the USA', sub: 'in the U.S.A.' },
        { icon: 'patch-check-fill', label: 'UL listed', short: 'UL listed', sub: '& ETL certified' },
        { icon: 'battery-full', label: 'Sealed batteries', short: '10-year batteries', sub: 'rated for 10 years' },
        { icon: 'cash-coin', label: 'No monitoring fees', short: 'No monitoring fees', sub: 'you own it outright' }
    ];

    return (
        <section style={{
            backgroundColor: Theme.colors.dark(),
            width: '100%'
        }}>
            <div style={{
                display: 'grid',
                gap: mobile ? '18px 14px' : 0,
                gridTemplateColumns: mobile ? '1fr 1fr' : 'repeat(4, 1fr)',
                margin: '0 auto',
                maxWidth: mobile ? 360 : Theme.layout.maxWidth,
                padding: mobile ? '22px 20px' : '28px 40px'
            }}>
                {items.map((item, index) => (
                    <div
                    key={index}
                    style={{
                        alignItems: 'center',
                        borderLeft: (mobile === false && index > 0) ? '1px solid rgba(255,255,255,0.14)' : 'none',
                        display: 'flex',
                        gap: mobile ? 9 : 14,
                        justifyContent: 'center'
                    }}>
                        <Icon name={item.icon} size={mobile ? 16 : 24} color={mobile ? Theme.colors.primaryOnDark() : Theme.colors.white} style={{ flexShrink: 0 }} />

                        {mobile ? (
                            <span style={{
                                color: Theme.colors.white,
                                fontFamily: Theme.fonts.body,
                                fontSize: 13,
                                fontWeight: 600,
                                whiteSpace: 'nowrap'
                            }}>{item.short}</span>
                        ) : (
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                lineHeight: 1.25
                            }}>
                                <span style={{
                                    color: Theme.colors.white,
                                    fontFamily: Theme.fonts.body,
                                    fontSize: 14,
                                    fontWeight: 700
                                }}>{item.label}</span>
                                <span style={{
                                    color: 'rgba(255,255,255,0.6)',
                                    fontFamily: Theme.fonts.body,
                                    fontSize: 13,
                                    fontWeight: 400
                                }}>{item.sub}</span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    )
}

export default TrustBar;
